import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  KeyboardView,
  Card,
  Video,
  Title,
  ContentfulRichText,
  Button,
  Copy,
  Bold
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";
import { openUrl, loadCancelReason } from "app/NativeActions";
import Resource from "./Resource";
class SecondVideoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_reason: props.selected_reason,
      selected_reason_loading: true
    };
  }

  componentDidMount() {
    if (this.props.selected_reason) {
      this.getData(this.props.selected_reason.fields.slug);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.selected_reason &&
      this.props.selected_reason !== prevProps.selected_reason
    ) {
      this.getData(this.props.selected_reason.fields.slug);
    }
  }

  getData(slug) {
    loadCancelReason(slug)
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState({
            selected_reason_loading: false,
            selected_reason: data.items[0]
          });
        }
        this.setState(() => ({ selected_reason_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ selected_reason_loading: false }));
      });
  }

  render() {
    const { cancel_page, device, offer, colors } = this.props;
    const { selected_reason } = this.state;
    return (
      <Wrapper style={{ flex: 1 }}>
        <Header
          title={cancel_page.title}
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => {
            this.props.setFirstCancelReason(null);
          }}
        />
        <KeyboardView
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Wrapper
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              margin: device == "desktop" ? "0px auto" : 0
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: 650,
                padding: 20
              }}
            >
              {selected_reason.fields.video ? (
                <Card
                  style={{
                    height: device == "desktop" ? 270 : 180,
                    width: device == "desktop" ? 480 : 320,
                    margin: device == "desktop" ? "0px auto" : 0,
                    overflow: "hidden"
                  }}
                >
                  <Video
                    video={selected_reason.fields.video.fields.file.url}
                    height={device == "desktop" ? 270 : 180}
                    width={device == "desktop" ? 480 : 320}
                    autoPlay={true}
                    controls={true}
                  />
                </Card>
              ) : null}
              <Wrapper style={{ paddingTop: 20, paddingBottom: 20 }}>
                <Title style={{ textAlign: "center", marginBottom: 10 }}>
                  {selected_reason.fields.title}
                </Title>
                <ContentfulRichText
                  style={{ textAlign: "center" }}
                  richText={selected_reason.fields.description}
                />
                {/* resources */}

                <Wrapper
                  style={{
                    borderColor: colors.border_color,
                    borderWidth: 1,
                    borderStyle: "solid",
                    borderRadius: 5,
                    borderTopWidth: 0
                  }}
                >
                  {offer ? (
                    <Resource
                      onPress={() => {
                        /*
                        this.props.pauseOrCancelPlan({
                          token: this.props.token,
                          type: "offer",
                          module_type: cancel_page.slug,
                          slug: offer.fields.slug,
                          url: offer.fields.buttonLink
                        });
                        */
                        switch (offer.fields.buttonType) {
                          case "link":
                          default:
                            openUrl(offer.fields.buttonLink);
                            break;
                        }
                        this.props.handleBack();
                      }}
                      resourceType={"offer"}
                      colors={colors}
                      buttonText={offer.fields.offerButtonTitle}
                    />
                  ) : null}
                  {selected_reason.fields.resources &&
                    selected_reason.fields.resources.map((resource, i) => {
                      if (resource.fields) {
                        return (
                          <Resource
                            key={"resource_" + i}
                            colors={colors}
                            resourceType={resource.fields.resourceType}
                            onPress={() => {
                              switch (resource.fields.buttonType) {
                                case "link":
                                default:
                                  openUrl(resource.fields.buttonLink);
                                  break;
                              }
                              this.props.handleBack();
                            }}
                            buttonText={resource.fields.buttonText}
                          />
                        );
                      }
                      return null;
                    })}
                </Wrapper>
              </Wrapper>

              <Wrapper>
                <Copy style={{ textAlign: "center" }}>
                  {selected_reason.fields.optionsTitle}
                </Copy>
                <Wrapper style={{ padding: 20, paddingBottom: 40 }}>
                  {selected_reason.fields.options &&
                    selected_reason.fields.options.map((option, i) => {
                      return (
                        <Button
                          key={"option_" + i}
                          onPress={() => {
                            this.props.setSecondCancelReason(option);
                          }}
                        >
                          <Card
                            style={{
                              padding: 15,
                              paddingRight: 30,
                              paddingLeft: 30,
                              borderRadius: 30,
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          >
                            <Copy style={{ textAlign: "center" }}>
                              <Bold>{option}</Bold>
                            </Copy>
                          </Card>
                        </Button>
                      );
                    })}
                </Wrapper>
              </Wrapper>
            </Wrapper>
          </Wrapper>
        </KeyboardView>
      </Wrapper>
    );
  }
}

export default SecondVideoPage;
